import styled from "styled-components";
import { Link } from "react-router-dom";
import theme from "../theme";

const Btn = styled(Link)`
    background: ${(props) => props.primary ? theme.primaryColor : theme.secundaryColor};
    width: ${(props) => props.withIcon ? '250px' : 'auto'};
    margin-left: 0;
    border: none;
    border-radius: 10px;
    color: ${theme.white };
    font-family: 'Montserrat', sans-serif;
    height: 40px;
    padding: 20px 30px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    outline: none;

    svg {
        height: ${(props) => props.BigIcon ? '100%' : '12px'};
        fill: white
    }
`
export default Btn; 